import { render, staticRenderFns } from "./Reverb.vue?vue&type=template&id=0f2e1988"
import script from "./Reverb.vue?vue&type=script&lang=js"
export * from "./Reverb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports